<div class="mat-typography app-frame mat-app-background">
<router-outlet></router-outlet>
</div>
